import { customAlphabet } from 'nanoid';

export class RandomHelper {
  static alphaNumeric(length: number = 12): string {
    const nanoid = customAlphabet('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz', length);
    return nanoid();
  }
}
